/**
 * Hotjar — queue stub immediately; load full script after idle / timeout or on first interaction.
 * In Theme Editor loads right away so previews behave as expected.
 */
(function (w, d) {
  w.hj =
    w.hj ||
    function () {
      (w.hj.q = w.hj.q || []).push(arguments);
    };
  w._hjSettings = { hjid: 6404961, hjsv: 6 };

  var loaded = false;

  function loadHotjar() {
    if (loaded) return;
    loaded = true;
    var s = d.createElement('script');
    s.async = true;
    s.src =
      'https://static.hotjar.com/c/hotjar-' +
      w._hjSettings.hjid +
      '.js?sv=' +
      w._hjSettings.hjsv;
    (d.head || d.body).appendChild(s);
  }

  if (d.documentElement.classList.contains('shopify-design-mode')) {
    loadHotjar();
    return;
  }

  function scheduleAfterLoad() {
    if ('requestIdleCallback' in w) {
      w.requestIdleCallback(
        function () {
          loadHotjar();
        },
        { timeout: 5000 }
      );
    } else {
      w.setTimeout(loadHotjar, 4000);
    }
  }

  if (d.readyState === 'complete') {
    scheduleAfterLoad();
  } else {
    w.addEventListener('load', scheduleAfterLoad);
  }

  ['scroll', 'click', 'touchstart', 'keydown'].forEach(function (ev) {
    d.addEventListener(ev, loadHotjar, { once: true, passive: true });
  });
})(window, document);
